<template>
  <div>Alarm</div>
</template>

<script>
export default {};
</script>

<style></style>
